export default __webpack_public_path__ + "static/media/bear_icon.de560d88.svg";